module.exports = __webpack_public_path__ + "img/line_new.f334540.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/line_new.svg
// module id = 1718
// module chunks = 1